export default {
  api: {
    bankAccount: {
      bank: {
        notNull: "Select a bank",
      },
      ibanSwift: {
        orRequired: "Provide and IBAN or Swift/BIC number",
      },
      iban: {
        invalid: "Invalid IBAN number",
      },
      currency: {
        notNull: "You need to select a currency in system settings",
      },
      found: "Bankaccount with same data already exists",
    },
  },
}
